import { render } from "./ChallengeList.vue?vue&type=template&id=3322ec1f"
import script from "./ChallengeList.vue?vue&type=script&lang=js"
export * from "./ChallengeList.vue?vue&type=script&lang=js"

import "./ChallengeList.vue?vue&type=style&index=0&id=3322ec1f&lang=css"

import exportComponent from "/home/hoxer/Dokumenter/GitHub/techecute/pwa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QSkeleton,QCardActions,QBtn});
